import React, { useEffect, useState } from "react";
import { Table, Badge, Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { getExerciseRequestsByEmployee } from "../../../apis/options/EmployeeApi";
import Dollars from "../../common/typeFormatting/Dollars";
import IntegerFmt from "../../common/typeFormatting/IntegerFmt";
import DateFmt from "../../common/typeFormatting/Date";

const PendingExerciseRequests = ({ employeeId }) => {
    const history = useHistory();
    const [exerciseRequests, setExerciseRequests] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        async function loadExerciseRequests() {
            try {
                setIsLoading(true);
                const requests = await getExerciseRequestsByEmployee(employeeId);
                // Only show pending requests
                const pendingRequests = requests.filter(req => req.status === "Pending");
                setExerciseRequests(pendingRequests);
                setError("");
            } catch (error) {
                console.error("Error loading exercise requests:", error);
                setError("Failed to load exercise requests.");
                setExerciseRequests([]);
            } finally {
                setIsLoading(false);
            }
        }

        if (employeeId) {
            loadExerciseRequests();
        }
    }, [employeeId]);

    const handleRequestClick = (exerciseRequestId) => {
        history.push(`/options/exercise-requests/${exerciseRequestId}`);
    };

    const getStatusBadge = (status) => {
        const variant = status === "Pending" ? "warning" : "secondary";
        return <Badge variant={variant}>{status}</Badge>;
    };

    const calculateTotalShares = (lineItems) => {
        return lineItems.reduce((sum, item) => sum + item.sharesToExercise, 0);
    };

    const calculateTotalProceeds = (lineItems) => {
        return lineItems.reduce((sum, item) => sum + item.estimatedProceeds, 0);
    };

    if (isLoading) {
        return <div>Loading pending exercise requests...</div>;
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    if (exerciseRequests.length === 0) {
        return null; // Render nothing when no pending requests
    }

    return (
        <div style={{ marginBottom: "20px" }}>
            <h6 style={{ marginBottom: "15px", color: "#6c757d" }}>
                Pending Exercise Requests ({exerciseRequests.length})
            </h6>
            <Table hover responsive size="sm" style={{ fontSize: 12, cursor: "pointer" }}>
                <thead style={{ backgroundColor: "#f8f9fa" }}>
                    <tr>
                        <th>Request ID</th>
                        <th>Request Date</th>
                        <th>Status</th>
                        <th className="text-center">Total Shares</th>
                        <th className="text-center">Estimated Proceeds</th>
                        <th className="text-center">Line Items</th>
                        <th>Notes</th>
                    </tr>
                </thead>
                <tbody>
                    {exerciseRequests.map((request) => (
                        <tr 
                            key={request.exerciseRequestId}
                            onClick={() => handleRequestClick(request.exerciseRequestId)}
                            style={{ cursor: "pointer" }}
                        >
                            <td style={{ fontWeight: "bold", color: "#007bff" }}>
                                {request.exerciseRequestId}
                            </td>
                            <td>
                                <DateFmt>{request.requestDate}</DateFmt>
                            </td>
                            <td>
                                {getStatusBadge(request.status)}
                            </td>
                            <td className="text-center">
                                <IntegerFmt>{calculateTotalShares(request.lineItems)}</IntegerFmt>
                            </td>
                            <td className="text-center">
                                <Dollars>{calculateTotalProceeds(request.lineItems)}</Dollars>
                            </td>
                            <td className="text-center">
                                {request.lineItems.length}
                            </td>
                            <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {request.notes || "-"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default PendingExerciseRequests;